import type { BirthdayEventType } from '@api';
import type { ScheduleEventData } from '@mantine/schedule';
import dayjs from 'dayjs';
import type { PayloadType } from '../../../../types';

type GetScheduledEventFromBdayDataReturnType = ScheduleEventData<PayloadType>[];

export const getScheduledEventFromBdayData = (
  records: BirthdayEventType[],
  viewYear: number
): GetScheduledEventFromBdayDataReturnType => {
  return records.map((bday) => {
    const { day, month } = bday.birthdate;

    return {
      id: `bday-${bday.person.id}`,
      title: bday.person.name,
      start: dayjs()
        .year(viewYear)
        .month((month ?? 1) - 1)
        .date(day ?? 1)
        .format('YYYY-MM-DD 00:00:00'),
      end: dayjs()
        .year(viewYear)
        .month((month ?? 1) - 1)
        .date(day ?? 1)
        .add(1, 'day')
        .format('YYYY-MM-DD 00:00:00'),
      color: 'blue',
      payload: {
        type: 'BDAY',
        birthday: bday,
      },
    };
  });
};
